import { useEffect, useState } from "react";
import AuthUser from "./AuthUser";
import toast, { Toaster } from "react-hot-toast";
import moment from "moment";
import { Link, Navigate, useLocation } from "react-router-dom";
import TaskSkeleton from "./TaskSkeleton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFile } from "@fortawesome/free-solid-svg-icons";
import Select from "react-select";
import { useNavigate } from 'react-router-dom';
import { useMemo } from 'react';
import './StudentUpload.css';
import XLSX from 'xlsx-js-style';

// Add modern table and filter styles
const modernTableStyles = `
    /* Modern Filter Card Styles */
    .modern-filter-card {
        background: white;
        border-radius: 8px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
        border: 1px solid #e9ecef;
        overflow: visible;
        position: relative;
        z-index: 1;
        margin-bottom: 1.5rem;
    }
    
    .filter-header {
        padding: 12px 16px;
        background: #f8f9fa;
        border-bottom: 1px solid #e9ecef;
        border-radius: 8px 8px 0 0;
    }
    
    .filter-icon {
        width: 32px;
        height: 32px;
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        border-radius: 6px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 10px;
        color: white;
        font-size: 13px;
    }
    
    .filter-title {
        color: #495057;
        font-weight: 600;
        font-size: 0.95rem;
        letter-spacing: 0.2px;
    }
    
    .filter-body {
        padding: 16px;
        background: white;
        border-radius: 0 0 8px 8px;
        position: relative;
        z-index: 10;
    }
    
    .filter-label {
        display: block;
        font-weight: 500;
        font-size: 0.875rem;
        color: #6c757d;
        margin-bottom: 8px;
        letter-spacing: 0.2px;
    }
    
    .filter-label i {
        color: #667eea;
        width: 16px;
        margin-right: 4px;
    }
    
    .modern-form-select {
        width: 100%;
        padding: 12px 16px;
        border: 2px solid #e9ecef;
        border-radius: 8px;
        font-size: 0.9rem;
        font-weight: 500;
        background: white;
        transition: all 0.3s ease;
        color: #495057;
    }
    
    .modern-form-select:focus {
        outline: none;
        border-color: #667eea;
        box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.25);
        transform: translateY(-1px);
    }
    
    .modern-form-select:hover {
        border-color: #667eea;
    }
    
    .filter-actions {
        display: flex;
        gap: 8px;
        height: 100%;
        align-items: flex-end;
    }
    
    .btn-search, .btn-clear {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        padding: 12px 20px;
        border-radius: 8px;
        font-weight: 500;
        font-size: 0.9rem;
        transition: all 0.2s ease;
        cursor: pointer;
        white-space: nowrap;
        min-width: 100px;
        border: 2px solid transparent;
    }
    
    .btn-search {
        background: #667eea;
        color: white;
        box-shadow: 0 2px 8px rgba(102, 126, 234, 0.2);
    }
    
    .btn-search:hover:not(:disabled) {
        background: #5a6fd8;
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
    }
    
    .btn-search:disabled {
        background: #6c757d;
        cursor: not-allowed;
        transform: none;
        box-shadow: none;
        opacity: 0.6;
    }
    
    .btn-clear {
        background: white;
        color: #6c757d;
        border: 2px solid #dee2e6;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    }
    
    .btn-clear:hover {
        background: #f8f9fa;
        border-color: #adb5bd;
        transform: translateY(-1px);
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    }
    
    .btn-search i, .btn-clear i {
        font-size: 14px;
    }
    
    /* Container adjustments */
    .container-fluid {
        overflow-x: visible;
    }

    /* Table Responsive Wrapper */
    .table-responsive {
        overflow-x: auto !important;
        -webkit-overflow-scrolling: touch;
        width: 100%;
        margin-bottom: 1rem;
        display: block;
    }

    /* Modern Table Styles */
    .modern-table {
        box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
        border-radius: 8px;
        overflow: hidden;
        border: none;
        font-size: 0.9rem;
        min-width: 1400px;
        width: 100%;
    }
    
    .modern-table thead th {
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        color: white;
        font-weight: 600;
        text-transform: uppercase;
        font-size: 0.8rem;
        letter-spacing: 0.5px;
        padding: 15px 8px;
        border: none;
        position: sticky;
        top: 0;
        z-index: 10;
    }
    
    .modern-table tbody tr {
        transition: all 0.3s ease;
        border-bottom: 1px solid #e9ecef;
    }
    
    .modern-table tbody tr:hover {
        background-color: #f8f9fa;
        transform: translateY(-1px);
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }
    
    .modern-table tbody td {
        padding: 12px 8px;
        vertical-align: middle;
        border: none;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    
    .modern-row.table-warning {
        background-color: #fff3cd !important;
        border-left: 4px solid #ffc107;
    }
    
    /* Compact table styling for more content */
    .modern-table {
        font-size: 0.85rem;
    }
    
    .modern-table thead th {
        font-size: 0.8rem;
        padding: 10px 8px;
    }
    
    .modern-table tbody td {
        font-size: 0.8rem;
        padding: 8px 6px;
    }
    
    .modern-table tbody td small {
        font-size: 0.75rem;
    }
    
    .modern-table .form-select-sm {
        font-size: 0.75rem;
        padding: 4px 8px;
    }
    
    .modern-table .btn-sm {
        font-size: 0.75rem;
        padding: 4px 8px;
    }
    
    .btn-group .btn {
        margin: 0 1px;
        border-radius: 4px;
    }
    
    .btn-group .btn:hover {
        transform: translateY(-1px);
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    }
    
    .badge {
        font-size: 0.75rem;
        padding: 4px 8px;
        border-radius: 12px;
    }
    
    /* Responsive Design */
    @media (max-width: 992px) {
        .filter-actions {
            margin-top: 16px;
        }
        
        .btn-search, .btn-clear {
            width: 100%;
            min-width: auto;
        }
        
        .modern-table {
            min-width: 1200px;
        }
    }
    
    @media (max-width: 768px) {
        .modern-table {
            font-size: 0.8rem;
            min-width: 1000px;
        }
        
        .modern-table thead th {
            padding: 10px 6px;
            font-size: 0.7rem;
        }
        
        .modern-table tbody td {
            padding: 8px 6px;
        }
        
        .filter-body {
            padding: 16px;
        }
        
        .filter-header {
            padding: 16px 16px 12px;
        }
        
        .btn-search span, .btn-clear span {
            display: none;
        }
        
        .btn-search, .btn-clear {
            min-width: 50px;
            padding: 12px;
        }
    }
`;

// Inject styles
if (typeof document !== 'undefined') {
    const styleSheet = document.createElement("style");
    styleSheet.innerText = modernTableStyles;
    document.head.appendChild(styleSheet);
}

const parseCsvText = (text) => {
    const rows = [];
    let row = [];
    let field = '';
    let inQuotes = false;
    for (let i = 0; i < text.length; i++) {
        const c = text[i];
        const next = text[i + 1];
        if (inQuotes) {
            if (c === '"' && next === '"') { field += '"'; i++; }
            else if (c === '"') inQuotes = false;
            else field += c;
        } else if (c === '"') {
            inQuotes = true;
        } else if (c === ',') {
            row.push(field);
            field = '';
        } else if (c === '\n' || (c === '\r' && next === '\n')) {
            row.push(field);
            field = '';
            if (row.some((cell) => cell !== '')) rows.push(row);
            row = [];
            if (c === '\r') i++;
        } else {
            field += c;
        }
    }
    if (field || row.length) {
        row.push(field);
        if (row.some((cell) => cell !== '')) rows.push(row);
    }
    return rows;
};

const isCellEmpty = (val) => val == null || String(val).trim() === '';

const filterEmptyColumns = (headers, dataRows) => {
    const keepIndices = headers
        .map((_, colIdx) => dataRows.some((row) => !isCellEmpty(row[colIdx])))
        .map((keep, i) => (keep ? i : -1))
        .filter((i) => i >= 0);

    return {
        headers: keepIndices.map((i) => headers[i]),
        rows: dataRows.map((row) => keepIndices.map((i) => row[i] ?? '')),
    };
};


export default function StudentListAll() {
    const { http, user } = AuthUser();
    const location = useLocation();
    const navigate = useNavigate();
    const [tasks, setTasks] = useState([]);
    const [hasAppliedLocationState, setHasAppliedLocationState] = useState(false);
    const [TotalCount, setTotalCount] = useState();
    const [TotalCountMRP, setTotalCountMRP] = useState();
    const [date, setDate] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [departments, setdepartments] = useState([]);
    const [currentStatus, setCurrentStatus] = useState(null);
    const [loginUser, setloginUser] = useState(user.department_id);
    const [selectedStatus, setsselectedStatus] = useState();
    const [selectedStatusFinal, setsselectedStatusFinal] = useState("OPEN");
    const [selectedtp, setsselectedtp] = useState();
    const [selectedPurpose, setsselectePuropse] = useState();
    const [selectedAssigner, setsselecteAssiner] = useState();
    const [showModal, setShowModal] = useState(false);
    const [editUser, setEditUser] = useState({});
    const [cat, setCat] = useState([]);
    const [masterdata, setmasterdata] = useState([]);
    const [masterdataIndi, setMasterdataIndi] = useState([]);
    const [tasksind, setTasksInd] = useState([]);
    const [editColumn, setEditColumn] = useState(null);
    const [users, setUsers] = useState([]);
    const [stClass, setStClass] = useState([]);
    const [allClasses, setAllClasses] = useState([]); // Store all classes
    const [classGroups, setClassGroups] = useState([]); // Store class groups
    const [selectedGroup, setSelectedGroup] = useState(null); // Selected group
    const [stDev, setstDev] = useState([]);
    const [stYear, setstYear] = useState([]);
    const [stAgent, setstAgent] = useState([]);
    const [allStudent, setAllStudent] = useState([]);
    const [selStudent, setselStudent] = useState([]);
    const [selectedStud, setSelectedStudent] = useState("");
    const [selectedClassStud, setselectedClassStud] = useState("1");
    const [selectedDevStud, setselectedDevStud] = useState("");
    const [selectedDevAgent, setselectedDevAgent] = useState("");
    const [selectedDevStudType, setselectedDevStudType] = useState("");
    const [message, setMessage] = useState('');
    const [companyName, setCompanyName] = useState('');
    const [exportingDesign, setExportingDesign] = useState(false);
    const [formData, setFormData] = useState({
        photo: '',
    })
    const [selectedNewOld, setSelectedNewOld] = useState("");
    
    // Load filter values from localStorage on mount
    // Skip loading from localStorage if agent is passed from location state
    const loadFiltersFromStorage = () => {
        // If agent is passed from location state, don't load from localStorage
        // We'll set it fresh in the agent fetch callback
        if (location.state?.agentName) {
            // Clear location state after reading to prevent conflicts
            return {
        student: null,
        class: "",
        dev: "",
        devType: "",
        agent: "",
        newOld: "",
        reported: "",
        year: ""
            };
        }
        
        // Only load from localStorage if no location state
        try {
            const savedFilters = localStorage.getItem('studentListAll_filters');
            if (savedFilters) {
                const parsed = JSON.parse(savedFilters);
                // Convert student back to object format if it exists (it's stored as string)
                if (parsed.student && typeof parsed.student === 'string') {
                    return {
                        ...parsed,
                        student: JSON.parse(parsed.student)
                    };
                }
                return parsed;
            }
        } catch (error) {
            console.error('Error loading filters from storage:', error);
        }
        return {
            student: null,
            class: "",
            dev: "",
            devType: "",
            agent: "",
            newOld: "",
            reported: "",
            year: ""
        };
    };

    const [filterValues, setFilterValues] = useState(loadFiltersFromStorage);

    // CSV Upload states
    const [showUploadModal, setShowUploadModal] = useState(false);
    const [csvFile, setCsvFile] = useState(null);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [isUploading, setIsUploading] = useState(false);
    const [uploadResults, setUploadResults] = useState(null);
    const [dragActive, setDragActive] = useState(false);
    const [headReceiptList, setHeadReceiptList] = useState([]);

    // Fees Template Assignment states
    const [feesTemplates, setFeesTemplates] = useState([]);
    const [studentsWithFees, setStudentsWithFees] = useState([]);
    const [showTemplateModal, setShowTemplateModal] = useState(false);
    const [selectedTemplateStudent, setSelectedTemplateStudent] = useState(null);
    const [selectedTemplateId, setSelectedTemplateId] = useState("");
    const [assigningTemplate, setAssigningTemplate] = useState(false);

    useEffect(() => {
        http.get(`/class?company_id=${user.company_id}`).then((res) => {
            const classes = res.data.data;
            setAllClasses(classes); // Store all classes
            setStClass(classes); // Initially show all classes
        });

        // Fetch class groups
        http.get(`/class_master_assign?company_id=${user.company_id}`).then((res) => {
            if (res.data.status === 'success') {
                setClassGroups(res.data.data);
                
                // Restore selected group from localStorage
                try {
                    const savedGroup = localStorage.getItem('studentListAll_selectedGroup');
                    if (savedGroup) {
                        const parsedGroup = JSON.parse(savedGroup);
                        const group = res.data.data.find(g => g.id === parsedGroup.value);
                        if (group) {
                            setSelectedGroup(parsedGroup);
                            // Filter classes based on group
                            if (group.classes) {
                                setStClass(group.classes);
                            }
                        }
                    }
                } catch (error) {
                    console.error('Error loading selected group:', error);
                }
            }
        }).catch((err) => {
            console.error('Error fetching class groups:', err);
        });

        http.get(`/student_all?company_id=${user.company_id}`).then((res) => {
            setAllStudent(res.data.data);
        });
        http.get(`/devision`).then((res) => {
            setstDev(res.data.data);
        });

        http.get(`/year`).then((res) => {
            setstYear(res.data.data);
        });

        http.get(`/agent?company_id=${user.company_id}`).then((res) => {
            setstAgent(res.data.data);
            
            // Check if agent name is passed from location state (from DueList or AgentReport)
            if (location.state?.agentName && res.data.data && !hasAppliedLocationState) {
                const agentName = location.state.agentName;
                const agentExists = res.data.data.find(agent => agent.name === agentName);
                if (agentExists) {
                    // Clear all filters and set only the agent filter (don't mix with localStorage)
                    const updated = {
                        student: null,
                        class: "",
                        dev: "",
                        devType: "",
                        agent: agentName,
                        newOld: "",
                        reported: "",
                        year: ""
                    };
                    
                    setFilterValues(updated);
                    setHasAppliedLocationState(true);
                    
                    // Clear localStorage to prevent conflicts when coming from navigation
                    try {
                        const toSave = {
                            ...updated,
                            student: null
                        };
                        localStorage.setItem('studentListAll_filters', JSON.stringify(toSave));
                    } catch (error) {
                        console.error('Error saving filters to storage:', error);
                    }
                    
                    // Clear location state to prevent re-applying on re-renders
                    if (navigate) {
                        navigate(location.pathname, { replace: true, state: {} });
                    }
                    
                    // Trigger search when agent is set from location state
                    // Small delay to ensure filter is set, then trigger search
                    setTimeout(() => {
                        const studentId = "";
                        fetchTaskDetails(
                            studentId,
                            "",
                            "",
                            "",
                            "",
                            agentName,
                            "",
                            ""
                        );
                    }, 100);
                }
            }
        });

        // Fetch head receipts from head_generals table
        http.get(`/head_generals?company_id=${user.company_id}`).then((res) => {
            if (Array.isArray(res.data.data)) {
                setHeadReceiptList(res.data.data);
            }
        }).catch((error) => {
            console.error("Error fetching head receipts:", error);
        });

        // Fetch fees master templates
        http.get(`/fees_master_templates?company_id=${user.company_id}`).then((res) => {
            setFeesTemplates(res.data.data || []);
        }).catch(() => {});

        http.get(`/companyinfo?login_user=${user.id}`).then((res) => {
            if (res.data?.data?.[0]?.company_name) {
                setCompanyName(res.data.data[0].company_name);
            }
        }).catch(() => {});
    }, []);

    // Check fees status when tasks change
    useEffect(() => {
        if (tasks.length > 0) {
            const ids = tasks.map(t => t.id).join(',');
            http.get(`/students_fees_status?company_id=${user.company_id}&student_ids=${ids}`)
                .then((res) => setStudentsWithFees(res.data.data || []))
                .catch(() => {});
        }
    }, [tasks]);

    const handleAssignTemplate = () => {
        if (!selectedTemplateId) { toast.error("Select a template"); return; }
        setAssigningTemplate(true);
        http.post('/assign_fees_template', {
            student_id: selectedTemplateStudent.id,
            template_id: parseInt(selectedTemplateId),
        })
            .then((res) => {
                setAssigningTemplate(false);
                if (res.data.success) {
                    toast.success("Fees assigned successfully!");
                    setShowTemplateModal(false);
                    setSelectedTemplateId("");
                    setSelectedTemplateStudent(null);
                    setStudentsWithFees(prev => [...prev, selectedTemplateStudent.id]);
                } else {
                    toast.error(res.data.message || "Error assigning fees");
                }
            })
            .catch((err) => {
                setAssigningTemplate(false);
                toast.error(err.response?.data?.message || "Error assigning fees");
            });
    };

    const fetchTaskDetails = (idStd, clasStd, devStd, tType, newOld, agent, reported, year) => {
        setIsLoading(true);
        // Build query parameters, only include reported if it has a value
        let reportedParam = reported !== '' && reported !== null ? `&reported=${reported}` : '';
        let yearParam = year !== '' && year !== null ? `&year=${year}` : '';
        let endpoint = `/student_marks?id=${idStd}&dev=${devStd}&class=${clasStd}&type=${tType}&new_old=${newOld}&company_id=${user.company_id}&agent=${agent}${reportedParam}${yearParam}`;

        http
            .get(endpoint)
            .then((res) => {
                setIsLoading(false);
                if (Array.isArray(res.data.data)) {
                    setTasks(res.data.data);
                    setTotalCount(res.data.total_count);
                    setTotalCountMRP(res.data.total_count_mrp);
                } else {
                    setIsLoading(false);
                    console.error("API response is not an array");
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.error("Error fetching tasks:", error);
            });
    };

    const handleHeadReceiptChange = async (studentId, headReceiptName, index) => {
        try {
            const selectedHeadReceipt = headReceiptList.find(hr => hr.name === headReceiptName);
            const alpha = selectedHeadReceipt ? selectedHeadReceipt.alpha || '' : '';

            const updateData = {
                head_receipt: headReceiptName,
                alpha: alpha
            };

            await http.put(`/student_edit/${studentId}`, updateData);
            
            // Update local state
            setTasks(prevTasks => {
                const newTasks = [...prevTasks];
                newTasks[index] = {
                    ...newTasks[index],
                    head_receipt: headReceiptName,
                    alpha: alpha
                };
                return newTasks;
            });

            toast.success("Head Receipt updated successfully!");
        } catch (error) {
            console.error("Error updating head receipt:", error);
            toast.error("Failed to update head receipt");
        }
    };

    const statusUpdate = (e) => {
        setCurrentStatus(e.target.value);
    };

    const handleSave = async (taskId) => {
        if (currentStatus === null || taskId === null) {
            toast.error("Please select proper status");
            return true;
        }
        try {
            const response = await http.put(
                `task_status_update?task_id=${taskId}&status=${encodeURIComponent(
                    currentStatus
                )}`
            );
            toast.success("Task status updated successfully !");
            fetchTaskDetails();
        } catch (error) {
            console.error("Error fetching tasks:", error);
            toast.error("Please select proper item");
        }
    };

    const initialState = {
        revised_date: "",
        revised_remark: "",
    };

    const handleChangeModal = (e) => {
        setFormData1({
            ...formData1,
            [e.target.name]: e.target.value,
        });
        if (e.target.name === "category") {
            fetchUsersForDepartment(e.target.value);
        }
        if (e.target.name === "master_id") {
            fetchMasterIndividual(e.target.value);
        }
    };

    const fetchUsersForDepartment = async (departmentId) => {
        try {
            const response = await http.get(`/master_cat?cat=${departmentId}`);
            setmasterdata(response.data.users);
        } catch (error) {
            console.error("Error fetching users:", error);
        }
    };

    const deleteTask = async (taskId) => {
        await http
            .delete(`/student_del/${taskId}`)
            .then((response) => {
                toast.success("Student Data Deleted successfully !");
                window.location.reload();
            })
            .catch((err) => {
                console.error("Error deleting task", err);
            });
    };



    const [formData1, setFormData1] = useState({
        master_id: "",
        status: "",
        final_status: "",
    });

    const openEditModal = async (index, userData) => {
        setEditColumn(index);
        setShowModal(true);
        setselStudent(userData);
    };

    const closeModal = () => {
        setShowModal(false);
        setEditColumn("");
        setselStudent("");
    };



    const fetchMasterIndividual = async (msterId) => {
        try {
            const response = await http.get(`/master_cat_indi?cat=${msterId}`);
            setMasterdataIndi(response.data.users);
        } catch (error) {
            console.error("Error fetching users:", error);
        }
    };

    const DropdownOption = ({ user }) => {
        return (
            <option key={user.id} value={user.id}>
                {user.item_name}
            </option>
        );
    };

    const noOptionsMessage = ({ inputValue }) => {
        if (isLoading) {
            return 'Loading...';
        } else if (!inputValue) {
            return 'Loading...';
        } else {
            return 'No options';
        }
    };

    const options = useMemo(() => {
        if (isLoading) {
            return [{ value: '', label: 'Loading...' }];
        }
        return allStudent.map((user) => ({
            value: user.id,
            label: `${user.adm_no} - ${user.ext_2} ${user.ext_3 ? user.ext_3 : ''}-${user.class}-${user.section}-${user.mobile}`,
        }));
    }, [allStudent, isLoading]);

    const handleSelectChange = (selectedOption) => {
        setSelectedStudent(selectedOption);
    };

    const handleGroupChange = (selectedOption) => {
        setSelectedGroup(selectedOption);
        
        // Save selected group to localStorage
        try {
            if (selectedOption) {
                localStorage.setItem('studentListAll_selectedGroup', JSON.stringify(selectedOption));
            } else {
                localStorage.removeItem('studentListAll_selectedGroup');
            }
        } catch (error) {
            console.error('Error saving selected group:', error);
        }
        
        if (!selectedOption) {
            // No group selected, show all classes
            setStClass(allClasses);
            setFilterValues(prev => {
                const updated = { ...prev, class: "" };
                // Save to localStorage
                try {
                    const toSave = {
                        ...updated,
                        student: updated.student ? JSON.stringify(updated.student) : null
                    };
                    localStorage.setItem('studentListAll_filters', JSON.stringify(toSave));
                } catch (error) {
                    console.error('Error saving filters to storage:', error);
                }
                return updated;
            });
        } else {
            // Group selected, filter classes
            const group = classGroups.find(g => g.id === selectedOption.value);
            if (group && group.classes) {
                setStClass(group.classes);
                setFilterValues(prev => {
                    const updated = { ...prev, class: "" }; // Reset class selection
                    // Save to localStorage
                    try {
                        const toSave = {
                            ...updated,
                            student: updated.student ? JSON.stringify(updated.student) : null
                        };
                        localStorage.setItem('studentListAll_filters', JSON.stringify(toSave));
                    } catch (error) {
                        console.error('Error saving filters to storage:', error);
                    }
                    return updated;
                });
            }
        }
    };

    const handleSelectChangeClass = (e) => {
        const selectedValue = e.target.value;
        setselectedClassStud(selectedValue);
    };

    const handleSelectChangeDev = (e) => {
        const selectedValueDev = e.target.value;
        setselectedDevStud(selectedValueDev);
    };

    const handleSelectChangeAgent = (e) => {
        const selectedValueDev = e.target.value;
        setselectedDevAgent(selectedValueDev);
    };

    const handleClearFields = () => {
        // Clear filters from state
        const clearedFilters = {
            student: null,
            class: "",
            dev: "",
            devType: "",
            agent: "",
            newOld: "",
            reported: "",
            year: ""
        };
        setFilterValues(clearedFilters);
        setSelectedGroup(null);
        setHasAppliedLocationState(false); // Reset location state flag
        
        // Clear from localStorage
        try {
            localStorage.removeItem('studentListAll_filters');
            localStorage.removeItem('studentListAll_selectedGroup');
        } catch (error) {
            console.error('Error clearing filters from storage:', error);
        }
        
        // Reset class list to show all classes
        setStClass(allClasses);
        
        // Clear tasks
        setTasks([]);
        setTotalCount(0);
        setTotalCountMRP(0);
    };


    const handleSelectChangeDevWay = (e) => {
        const selectedValueDevType = e.target.value;
        setselectedDevStudType(selectedValueDevType);
    };

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            const newFormData = new FormData();
            newFormData.append('photo', file);
            setFormData(newFormData);
            console.log('File appended to FormData:', file);
        } else {
            console.log('No file selected');
        }

    };

    const saveEditedCustemer = async (e) => {
        e.preventDefault();
        try {
            console.log('Submitting form data:', formData);
            await http.post(`/photoEdit/${editColumn}`, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
            toast.success("Profile image updated successfully!");
        } catch (error) {
            console.error('Error updating student:', error.response?.data || error.message);

            // More specific error messages based on the error type
            if (error.response?.status === 413) {
                toast.error("Image file is too large. Please upload a smaller image.");
            } else if (error.response?.status === 415) {
                toast.error("Invalid file format. Please upload a valid image file.");
            } else if (error.response?.data?.message) {
                // Use server-provided error message if available
                toast.error(error.response.data.message);
            } else {
                toast.error("Failed to update profile image. Please try again.");
            }
        }
        setEditColumn("");
        closeModal();
    };

    const handleExport = () => {
        http.get(`export-students?company_id=${user.company_id}`, {
            responseType: 'blob', // Important to handle the binary data
        })
            .then(response => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'students.csv');
                document.body.appendChild(link);
                link.click();
                link.parentNode.removeChild(link);
                setMessage('Students exported successfully');
            })
            .catch(error => {
                console.error('Export failed:', error);
                setMessage('Failed to export students');
            });
    };

    const handleExportDesign = async () => {
        setExportingDesign(true);
        try {
            const response = await http.get(`export-students?company_id=${user.company_id}`, {
                responseType: 'text',
            });
            const parsed = parseCsvText(response.data);
            if (parsed.length < 2) {
                toast.error('No student data to export');
                return;
            }

            const [rawHeaders, ...rawRows] = parsed;
            const { headers, rows } = filterEmptyColumns(rawHeaders, rawRows);
            if (!headers.length) {
                toast.error('No data columns to export');
                return;
            }

            const colCount = headers.length;
            const titleRow = 0;
            const subtitleRow = 1;
            const metaRow = 2;
            const headerRow = 4;
            const dataStartRow = 5;

            const wsData = [];
            wsData[titleRow] = [companyName || 'Student List'];
            wsData[subtitleRow] = ['Student List Report'];
            wsData[metaRow] = [`Generated: ${moment().format('DD MMM, YYYY hh:mm A')}  |  Total Students: ${rows.length}`];
            wsData[headerRow] = headers;
            rows.forEach((row, i) => {
                wsData[dataStartRow + i] = row;
            });

            const ws = XLSX.utils.aoa_to_sheet(wsData);

            const companyStyle = {
                font: { bold: true, sz: 16, color: { rgb: '1A237E' } },
                alignment: { horizontal: 'center', vertical: 'center' },
            };
            const subtitleStyle = {
                font: { bold: true, sz: 12, color: { rgb: 'FFFFFF' } },
                fill: { fgColor: { rgb: '1A237E' } },
                alignment: { horizontal: 'center', vertical: 'center' },
            };
            const metaStyle = {
                font: { sz: 10, color: { rgb: '555555' } },
                alignment: { horizontal: 'center', vertical: 'center' },
            };
            const headerStyle = {
                font: { bold: true, color: { rgb: 'FFFFFF' }, sz: 10 },
                fill: { fgColor: { rgb: '1A237E' } },
                alignment: { horizontal: 'center', vertical: 'center', wrapText: true },
                border: {
                    top: { style: 'thin', color: { rgb: '1A237E' } },
                    bottom: { style: 'thin', color: { rgb: '1A237E' } },
                    left: { style: 'thin', color: { rgb: '1A237E' } },
                    right: { style: 'thin', color: { rgb: '1A237E' } },
                },
            };
            const cellBorder = {
                border: {
                    top: { style: 'thin', color: { rgb: 'DDDDDD' } },
                    bottom: { style: 'thin', color: { rgb: 'DDDDDD' } },
                    left: { style: 'thin', color: { rgb: 'DDDDDD' } },
                    right: { style: 'thin', color: { rgb: 'DDDDDD' } },
                },
            };

            const titleRef = XLSX.utils.encode_cell({ r: titleRow, c: 0 });
            if (ws[titleRef]) ws[titleRef].s = companyStyle;

            const subtitleRef = XLSX.utils.encode_cell({ r: subtitleRow, c: 0 });
            if (ws[subtitleRef]) ws[subtitleRef].s = subtitleStyle;

            const metaRef = XLSX.utils.encode_cell({ r: metaRow, c: 0 });
            if (ws[metaRef]) ws[metaRef].s = metaStyle;

            headers.forEach((_, ci) => {
                const ref = XLSX.utils.encode_cell({ r: headerRow, c: ci });
                if (ws[ref]) ws[ref].s = headerStyle;
            });

            rows.forEach((_, ri) => {
                const er = dataStartRow + ri;
                const altFill = ri % 2 === 0 ? { fgColor: { rgb: 'F2F6FC' } } : { fgColor: { rgb: 'FFFFFF' } };
                for (let ci = 0; ci < colCount; ci++) {
                    const ref = XLSX.utils.encode_cell({ r: er, c: ci });
                    if (ws[ref]) {
                        ws[ref].s = {
                            font: { sz: 9 },
                            fill: altFill,
                            alignment: { vertical: 'center', wrapText: true },
                            ...cellBorder,
                        };
                    }
                }
            });

            ws['!merges'] = [
                { s: { r: titleRow, c: 0 }, e: { r: titleRow, c: colCount - 1 } },
                { s: { r: subtitleRow, c: 0 }, e: { r: subtitleRow, c: colCount - 1 } },
                { s: { r: metaRow, c: 0 }, e: { r: metaRow, c: colCount - 1 } },
            ];
            ws['!rows'] = [{ hpt: 28 }, { hpt: 22 }, { hpt: 18 }, { hpt: 8 }, { hpt: 24 }];
            ws['!cols'] = headers.map((h, ci) => {
                const maxLen = Math.max(
                    String(h).length,
                    ...rows.map((row) => String(row[ci] ?? '').length)
                );
                return { wch: Math.min(Math.max(maxLen + 2, 8), 32) };
            });

            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Students');
            XLSX.writeFile(wb, `students_design_${moment().format('YYYYMMDD_HHmm')}.xlsx`);
            toast.success(`Design export ready (${rows.length} students, ${headers.length} columns)`);
            setMessage('Design export completed successfully');
        } catch (error) {
            console.error('Design export failed:', error);
            toast.error('Failed to export design file');
            setMessage('Failed to export design file');
        } finally {
            setExportingDesign(false);
        }
    };

    const handleSelectChangeNewOld = (e) => {
        const selectedValue = e.target.value;
        setSelectedNewOld(selectedValue);
    };

    const handleFilterChange = (field, value) => {
        setFilterValues(prev => {
            const updated = {
            ...prev,
            [field]: value
            };
            // Save to localStorage
            try {
                const toSave = {
                    ...updated,
                    student: updated.student ? JSON.stringify(updated.student) : null
                };
                localStorage.setItem('studentListAll_filters', JSON.stringify(toSave));
            } catch (error) {
                console.error('Error saving filters to storage:', error);
            }
            return updated;
        });
    };

    const handleFilterSubmit = () => {
        const studentId = filterValues.student?.value || "";
        fetchTaskDetails(
            studentId,
            filterValues.class,
            filterValues.dev,
            filterValues.devType,
            filterValues.newOld,
            filterValues.agent,
            filterValues.reported,
            filterValues.year
        );
    };

    const isAnyFilterSelected = () => {
        return (
            filterValues.student !== null ||
            filterValues.class !== "" ||
            filterValues.dev !== "" ||
            filterValues.devType !== "" ||
            filterValues.agent !== "" ||
            filterValues.newOld !== "" ||
            filterValues.reported !== "" ||
            filterValues.year !== ""
        );
    };

    // Auto-apply filters on mount if they were previously set (but not if coming from location state - that's handled separately)
    useEffect(() => {
        // Don't auto-apply if we're applying location state (it will trigger its own search)
        if (hasAppliedLocationState) {
            return;
        }
        
        const hasFilters = isAnyFilterSelected();
        
        if (hasFilters && allStudent.length > 0 && stClass.length > 0 && stDev.length > 0 && stAgent.length > 0) {
            // Small delay to ensure all data is loaded
            const timer = setTimeout(() => {
                handleFilterSubmit();
            }, 300);
            return () => clearTimeout(timer);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [allStudent.length, stClass.length, stDev.length, stAgent.length, hasAppliedLocationState]);

    // CSV Upload functions
    const openUploadModal = () => {
        setShowUploadModal(true);
        setCsvFile(null);
        setUploadProgress(0);
        setUploadResults(null);
        setIsUploading(false);
    };

    const closeUploadModal = () => {
        setShowUploadModal(false);
        setCsvFile(null);
        setUploadProgress(0);
        setUploadResults(null);
        setIsUploading(false);
        setDragActive(false);
    };

    const handleDrag = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (e.type === "dragenter" || e.type === "dragover") {
            setDragActive(true);
        } else if (e.type === "dragleave") {
            setDragActive(false);
        }
    };

    const handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setDragActive(false);
        
        if (e.dataTransfer.files && e.dataTransfer.files[0]) {
            const file = e.dataTransfer.files[0];
            if (file.type === "text/csv" || file.name.endsWith('.csv')) {
                setCsvFile(file);
            } else {
                toast.error("Please upload a CSV file");
            }
        }
    };

    const handleFileSelect = (e) => {
        const file = e.target.files[0];
        if (file) {
            if (file.type === "text/csv" || file.name.endsWith('.csv')) {
                setCsvFile(file);
            } else {
                toast.error("Please upload a CSV file");
                e.target.value = '';
            }
        }
    };

    const simulateProgress = () => {
        setUploadProgress(0);
        const interval = setInterval(() => {
            setUploadProgress(prev => {
                if (prev >= 90) {
                    clearInterval(interval);
                    return 90;
                }
                return prev + Math.random() * 15;
            });
        }, 200);
        return interval;
    };

    const handleCsvUpload = async () => {
        if (!csvFile) {
            toast.error("Please select a CSV file");
            return;
        }

        setIsUploading(true);
        setUploadResults(null);
        
        const progressInterval = simulateProgress();

        const formData = new FormData();
        formData.append('csv_file', csvFile);

        try {
            const response = await http.post('/student_upload', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });

            clearInterval(progressInterval);
            setUploadProgress(100);

            setTimeout(() => {
                setIsUploading(false);
                setUploadResults(response.data);
                
                if (response.data.success) {
                    toast.success(`Successfully uploaded ${response.data.summary.successful} students!`);
                    // Refresh the student list if any filters are applied
                    if (isAnyFilterSelected()) {
                        handleFilterSubmit();
                    }
                } else {
                    toast.error("Upload completed with errors. Check the details below.");
                }
            }, 500);

        } catch (error) {
            clearInterval(progressInterval);
            setIsUploading(false);
            setUploadProgress(0);
            
            console.error('Upload failed:', error);
            
            if (error.response?.data?.message) {
                toast.error(error.response.data.message);
                setUploadResults(error.response.data);
            } else {
                toast.error("Upload failed. Please try again.");
            }
        }
    };

    const resetUpload = () => {
        setCsvFile(null);
        setUploadProgress(0);
        setUploadResults(null);
        setIsUploading(false);
    };

    return (
        <>
            <Toaster />
            <div className="mt-2 mb-2">
                {message && <p class="alert alert-success" role="alert">{message}</p>}
            </div>
            {showModal && (
                <form onSubmit={saveEditedCustemer}>
                    <div className="modal" tabindex="-1" style={{ display: "block" }}>
                        <div className="modal-dialog">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Upload Profile Image</h5>
                                </div>

                                <div className="form-group p-2">
                                    <label>Admition No: {selStudent.adm_no} </label>
                                    <label><b></b></label>
                                </div>

                                <div className="form-group p-2">
                                    <label>Name: </label>
                                    <label><b>{selStudent.ext_2} {selStudent.ext_3}</b></label>
                                </div>

                                <div className="form-group p-2">
                                    <label>Class: {selStudent.class}</label>
                                    <label><b></b></label>
                                </div>

                                <div className="form-group  p-2">
                                    <label>Dev: </label>
                                    <label><b>{selStudent.section}</b></label>
                                </div>

                                <div className="form-group mt-3 p-3">
                                    <label>Photo</label>
                                    <input type="file" className="form-control" name='photo' onChange={handleFileChange} />
                                </div>

                                <div className="modal-footer">
                                    <button
                                        type="button"
                                        className="btn btn-secondary"
                                        onClick={closeModal}
                                    >
                                        Close
                                    </button>
                                    <button type="submit" className="btn btn-primary">
                                        Save changes
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            )}

            {/* CSV Upload Modal */}
            {showUploadModal && (
                <div className="modal upload-modal" tabIndex="-1" style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}>
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">
                                    📤 Upload Students CSV
                                </h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={closeUploadModal}
                                    disabled={isUploading}
                                ></button>
                            </div>
                            
                            <div className="modal-body">
                                {!uploadResults && (
                                    <>
                                        {/* File Upload Area */}
                                        <div
                                            className={`upload-area border-2 border-dashed rounded-lg p-4 text-center mb-3 ${
                                                dragActive ? 'drag-active' : 'border-secondary'
                                            } ${isUploading ? 'uploading' : ''}`}
                                            onDragEnter={handleDrag}
                                            onDragLeave={handleDrag}
                                            onDragOver={handleDrag}
                                            onDrop={handleDrop}
                                            style={{ minHeight: '120px', cursor: isUploading ? 'not-allowed' : 'pointer' }}
                                        >
                                            {csvFile ? (
                                                <div className="d-flex flex-column align-items-center">
                                                    <div className="mb-2">
                                                        <i className="fas fa-file-csv fa-3x file-icon"></i>
                                                    </div>
                                                    <h6 className="mb-1">{csvFile.name}</h6>
                                                    <small className="text-muted">
                                                        {(csvFile.size / 1024).toFixed(2)} KB
                                                    </small>
                                                    {!isUploading && (
                                                        <button
                                                            className="btn btn-sm btn-outline-danger mt-2"
                                                            onClick={() => setCsvFile(null)}
                                                        >
                                                            Remove
                                                        </button>
                                                    )}
                                                </div>
                                            ) : (
                                                <div>
                                                    <div className="mb-3">
                                                        <i className="fas fa-cloud-upload-alt fa-3x text-muted"></i>
                                                    </div>
                                                    <h6>Drag & drop your CSV file here</h6>
                                                    <p className="text-muted mb-2">or</p>
                                                    <label className="btn btn-outline-primary">
                                                        Browse Files
                                                        <input
                                                            type="file"
                                                            accept=".csv"
                                                            onChange={handleFileSelect}
                                                            style={{ display: 'none' }}
                                                            disabled={isUploading}
                                                        />
                                                    </label>
                                                </div>
                                            )}
                                        </div>

                                        {/* CSV Format Info */}
                                        <div className="alert alert-info">
                                            <h6><i className="fas fa-info-circle"></i> CSV Format Requirements:</h6>
                                            <ul className="mb-0 small">
                                                <li>Include headers: adm_no, ext_2 (first name), ext_3 (last name), class, section, company_id, user_id</li>
                                                <li>Make sure company_id and user_id are included for each student</li>
                                                <li>Admission numbers must be unique within your company</li>
                                                <li>Maximum file size: 10MB</li>
                                            </ul>
                                        </div>

                                        {/* Progress Bar */}
                                        {isUploading && (
                                            <div className="mb-3">
                                                <div className="d-flex justify-content-between align-items-center mb-2">
                                                    <span className="small fw-bold">Uploading...</span>
                                                    <span className="small">{Math.round(uploadProgress)}%</span>
                                                </div>
                                                <div className="progress" style={{ height: '8px' }}>
                                                    <div
                                                        className="progress-bar progress-bar-striped progress-bar-animated progress-bar-custom"
                                                        role="progressbar"
                                                        style={{ width: `${uploadProgress}%` }}
                                                    ></div>
                                                </div>
                                            </div>
                                        )}
                                    </>
                                )}

                                {/* Upload Results */}
                                {uploadResults && (
                                    <div className="mt-3">
                                        <div className={`alert ${uploadResults.success ? 'alert-success' : 'alert-warning'}`}>
                                            <h6>
                                                <i className={`fas ${uploadResults.success ? 'fa-check-circle' : 'fa-exclamation-triangle'}`}></i>
                                                {' '}{uploadResults.message}
                                            </h6>
                                            
                                            {uploadResults.summary && (
                                                <div className="mt-3">
                                                    <div className="row text-center">
                                                        <div className="col-3">
                                                            <div className="border rounded p-2 stats-card">
                                                                <div className="h4 mb-0 text-primary">{uploadResults.summary.total_rows}</div>
                                                                <small>Total Rows</small>
                                                            </div>
                                                        </div>
                                                        <div className="col-3">
                                                            <div className="border rounded p-2 stats-card">
                                                                <div className="h4 mb-0 text-success">{uploadResults.summary.successful}</div>
                                                                <small>Successful</small>
                                                            </div>
                                                        </div>
                                                        <div className="col-3">
                                                            <div className="border rounded p-2 stats-card">
                                                                <div className="h4 mb-0 text-danger">{uploadResults.summary.errors}</div>
                                                                <small>Errors</small>
                                                            </div>
                                                        </div>
                                                        <div className="col-3">
                                                            <div className="border rounded p-2 stats-card">
                                                                <div className="h4 mb-0 text-warning">{uploadResults.summary.duplicates}</div>
                                                                <small>Duplicates</small>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>

                                        {/* Error Details */}
                                        {uploadResults.errors && uploadResults.errors.length > 0 && (
                                            <div className="mt-3">
                                                <h6 className="text-danger">
                                                    <i className="fas fa-exclamation-circle"></i> Errors:
                                                </h6>
                                                <div className="error-list p-2" style={{ maxHeight: '200px', overflowY: 'auto' }}>
                                                    {uploadResults.errors.map((error, index) => (
                                                        <div key={index} className="small mb-1">
                                                            <strong>Row {error.row}:</strong> {error.message}
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        )}

                                        {/* Duplicate Details */}
                                        {uploadResults.duplicates && uploadResults.duplicates.length > 0 && (
                                            <div className="mt-3">
                                                <h6 className="text-warning">
                                                    <i className="fas fa-copy"></i> Duplicates:
                                                </h6>
                                                <div className="duplicate-list p-2" style={{ maxHeight: '200px', overflowY: 'auto' }}>
                                                    {uploadResults.duplicates.map((duplicate, index) => (
                                                        <div key={index} className="small mb-1">
                                                            <strong>Row {duplicate.row}:</strong> {duplicate.message} 
                                                            {duplicate.adm_no && <span className="text-muted"> (Adm No: {duplicate.adm_no})</span>}
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                            
                            <div className="modal-footer">
                                {!uploadResults ? (
                                    <>
                                        <button
                                            type="button"
                                            className="btn btn-secondary"
                                            onClick={closeUploadModal}
                                            disabled={isUploading}
                                        >
                                            Cancel
                                        </button>
                                        <button
                                            type="button"
                                            className="btn btn-primary upload-button"
                                            onClick={handleCsvUpload}
                                            disabled={!csvFile || isUploading}
                                        >
                                            {isUploading ? (
                                                <>
                                                    <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                                                    Uploading...
                                                </>
                                            ) : (
                                                <>
                                                    <i className="fas fa-upload me-2"></i>
                                                    Upload CSV
                                                </>
                                            )}
                                        </button>
                                    </>
                                ) : (
                                    <>
                                        <button
                                            type="button"
                                            className="btn btn-outline-primary"
                                            onClick={resetUpload}
                                        >
                                            Upload Another File
                                        </button>
                                        <button
                                            type="button"
                                            className="btn btn-primary"
                                            onClick={closeUploadModal}
                                        >
                                            Close
                                        </button>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <div className="container-fluid px-4" style={{ paddingTop: '1rem', paddingBottom: '1rem' }}>
                <div className="row align-items-center mb-3">
                    <div className="col-md-6">
                        <h3 className="mb-0">
                            Student List
                        </h3>
                    </div>

                        <div className="col-md-6 text-end">
                        {(user.status === 1 ) && (
                            <Link className="add_link" to="/student_add" style={{ marginRight: '10px' }}>
                                Add Student
                            </Link>
                        )}
                        {(user.status === 1 && user.department_id === 1) && (
                            <div>
                            <button 
                                onClick={openUploadModal} 
                                className="btn btn-success me-2"
                                style={{ marginRight: '10px' }}
                            >
                                📤 Upload CSV
                            </button>
                            <button
                                onClick={handleExportDesign}
                                className="btn btn-primary me-2"
                                disabled={exportingDesign}
                                title="Styled export with blue header; empty columns removed"
                            >
                                {exportingDesign ? (
                                    <><span className="spinner-border spinner-border-sm me-1"></span>Exporting...</>
                                ) : (
                                    <><i className="fas fa-file-excel me-1"></i>Export Design CSV</>
                                )}
                            </button>
                            <a onClick={handleExport} className="button btn-primary btn">
                                Export
                            </a>
                            </div>
                             )}
                        </div>
                   
                </div>

                <div className="row">
                    <div className="col-12">
                        <div className="modern-filter-card">
                        <div className="filter-body p-3">
                            <div className="row g-2 align-items-end">
                                <div className="col-auto">
                                    <label className="small text-muted mb-1 d-block">Student</label>
                                    <Select
                                        options={options}
                                        onChange={(value) => handleFilterChange('student', value)}
                                        value={filterValues.student}
                                        isDisabled={isLoading}
                                        noOptionsMessage={noOptionsMessage}
                                        placeholder="Select..."
                                        menuPortalTarget={document.body}
                                        styles={{
                                            control: (base) => ({ ...base, minHeight: '36px', fontSize: '12px', minWidth: '280px', maxWidth: '280px' }),
                                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                            menu: (base) => ({ ...base, minWidth: '320px' }),
                                            singleValue: (base) => ({ ...base, fontSize: '12px' })
                                        }}
                                    />
                                </div>
                                <div className="col-auto">
                                    <label className="small text-muted mb-1 d-block">Group</label>
                                    <Select
                                        options={classGroups.map((g) => ({ value: g.id, label: g.name }))}
                                        onChange={handleGroupChange}
                                        value={selectedGroup}
                                        isClearable
                                        placeholder="All"
                                        menuPortalTarget={document.body}
                                        styles={{
                                            control: (base) => ({ ...base, minHeight: '36px', fontSize: '12px', minWidth: '80px' }),
                                            menuPortal: (base) => ({ ...base, zIndex: 9999 })
                                        }}
                                    />
                                </div>
                                <div className="col-auto">
                                    <label className="small text-muted mb-1 d-block">Class</label>
                                    <Select
                                        options={stClass.map((c) => ({ value: c.class_name, label: c.class_name }))}
                                        onChange={(opt) => handleFilterChange('class', opt ? opt.value : '')}
                                        value={filterValues.class ? { value: filterValues.class, label: filterValues.class } : null}
                                        isClearable
                                        placeholder="All"
                                        menuPortalTarget={document.body}
                                        styles={{
                                            control: (base) => ({ ...base, minHeight: '36px', fontSize: '12px', minWidth: '160px' }),
                                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                            menu: (base) => ({ ...base, minWidth: '180px' })
                                        }}
                                    />
                                </div>
                                <div className="col-auto">
                                    <label className="small text-muted mb-1 d-block">Div</label>
                                    <Select
                                        options={stDev.map((d) => ({ value: d.name, label: d.name }))}
                                        onChange={(opt) => handleFilterChange('dev', opt ? opt.value : '')}
                                        value={filterValues.dev ? { value: filterValues.dev, label: filterValues.dev } : null}
                                        isClearable
                                        placeholder="All"
                                        menuPortalTarget={document.body}
                                        styles={{
                                            control: (base) => ({ ...base, minHeight: '36px', fontSize: '12px', minWidth: '65px' }),
                                            menuPortal: (base) => ({ ...base, zIndex: 9999 })
                                        }}
                                    />
                                </div>
                                <div className="col-auto">
                                    <label className="small text-muted mb-1 d-block">Agent</label>
                                    <Select
                                        options={stAgent.map((a) => ({ value: a.name, label: a.name }))}
                                        onChange={(opt) => handleFilterChange('agent', opt ? opt.value : '')}
                                        value={filterValues.agent ? { value: filterValues.agent, label: filterValues.agent } : null}
                                        isClearable
                                        placeholder="All"
                                        menuPortalTarget={document.body}
                                        styles={{
                                            control: (base) => ({ ...base, minHeight: '36px', fontSize: '12px', minWidth: '100px' }),
                                            menuPortal: (base) => ({ ...base, zIndex: 9999 })
                                        }}
                                    />
                                </div>
                                <div className="col-auto">
                                    <label className="small text-muted mb-1 d-block">Reported</label>
                                    <Select
                                        options={[{ value: '1', label: 'Yes' }, { value: '0', label: 'No' }]}
                                        onChange={(opt) => handleFilterChange('reported', opt ? opt.value : '')}
                                        value={filterValues.reported ? { value: filterValues.reported, label: filterValues.reported === '1' ? 'Yes' : 'No' } : null}
                                        isClearable
                                        placeholder="All"
                                        menuPortalTarget={document.body}
                                        styles={{
                                            control: (base) => ({ ...base, minHeight: '36px', fontSize: '12px', minWidth: '75px' }),
                                            menuPortal: (base) => ({ ...base, zIndex: 9999 })
                                        }}
                                    />
                                </div>
                                <div className="col-auto">
                                    <label className="small text-muted mb-1 d-block">Type</label>
                                    <Select
                                        options={[{ value: 'New', label: 'New' }, { value: 'Old', label: 'Old' }]}
                                        onChange={(opt) => handleFilterChange('newOld', opt ? opt.value : '')}
                                        value={filterValues.newOld ? { value: filterValues.newOld, label: filterValues.newOld } : null}
                                        isClearable
                                        placeholder="All"
                                        menuPortalTarget={document.body}
                                        styles={{
                                            control: (base) => ({ ...base, minHeight: '36px', fontSize: '12px', minWidth: '70px' }),
                                            menuPortal: (base) => ({ ...base, zIndex: 9999 })
                                        }}
                                    />
                                </div>
                                <div className="col-auto">
                                    <label className="small text-muted mb-1 d-block">Year</label>
                                    <Select
                                        options={stYear.map((y) => ({ value: y.name, label: y.name }))}
                                        onChange={(opt) => handleFilterChange('year', opt ? opt.value : '')}
                                        value={filterValues.year ? { value: filterValues.year, label: filterValues.year } : null}
                                        isClearable
                                        placeholder="All"
                                        menuPortalTarget={document.body}
                                        styles={{
                                            control: (base) => ({ ...base, minHeight: '36px', fontSize: '12px', minWidth: '90px' }),
                                            menuPortal: (base) => ({ ...base, zIndex: 9999 })
                                        }}
                                    />
                                </div>
                                <div className="col-auto">
                                    <button onClick={handleFilterSubmit} className="btn btn-primary btn-sm me-1" disabled={!isAnyFilterSelected()}>
                                        <i className="fas fa-search"></i> Search
                                    </button>
                                    <button onClick={handleClearFields} className="btn btn-secondary btn-sm">
                                        <i className="fas fa-times"></i> Clear
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                </div>

                <div className="row">
                    <div className="col-12">
                        <div className="table-responsive">
                        {isLoading ? (
                        <TaskSkeleton />
                    ) : tasks.length > 0 ? (
                        <table className="table table-hover modern-table">
                            <thead className="table-dark">
                                <tr>
                                    <th scope="col" style={{ width: '3%', minWidth: '40px' }} className="text-center">No</th>
                                    <th scope="col" style={{ width: '8%', minWidth: '100px' }}>Adm Date</th>
                                    <th scope="col" style={{ width: '7%', minWidth: '80px' }}>Adm No</th>
                                    <th scope="col" style={{ width: '12%', minWidth: '120px' }}>First Name</th>
                                    <th scope="col" style={{ width: '12%', minWidth: '120px' }}>Last Name</th>
                                    <th scope="col" style={{ width: '6%', minWidth: '60px' }}>Type</th>
                                    <th scope="col" style={{ width: '7%', minWidth: '70px' }}>Way</th>
                                    <th scope="col" style={{ width: '8%', minWidth: '80px' }}>Standard</th>
                                    <th scope="col" style={{ width: '5%', minWidth: '50px' }}>Div</th>
                                    <th scope="col" style={{ width: '9%', minWidth: '100px' }}>Phone</th>
                                    <th scope="col" style={{ width: '8%', minWidth: '80px' }}>Agent</th>
                                    {/* <th scope="col" style={{ width: '8%', minWidth: '80px' }}>Head Receipt</th> */}
                                    <th scope="col" style={{ width: '6%', minWidth: '60px' }}>Alpha</th>
                                    <th scope="col" style={{ width: '7%', minWidth: '70px' }}>Reported</th>
                                    <th scope="col" style={{ width: '15%', minWidth: '150px' }} className="text-center">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {tasks.map((taskuser, index) => (
                                    <tr
                                        className={`modern-row ${editColumn === index ? "table-warning" : ""}`}
                                        key={taskuser.id}
                                    >
                                        <td className="text-center fw-bold text-primary">{index + 1}</td>
                                        <td className="text-nowrap">
                                            <small>{moment(taskuser.adm_date).format("DD MMM,YYYY")}</small>
                                        </td>
                                        <td className="fw-semibold">{taskuser.adm_no}</td>
                                        <td className="text-capitalize">
                                            {taskuser.ext_2}
                                            <Link 
                                                to={`/bill_list/${taskuser.id}`}
                                                className="ms-2"
                                                title="View Bills"
                                                style={{ textDecoration: 'none' }}
                                            >
                                                <i className="fas fa-link text-primary"></i>
                                            </Link>
                                        </td>
                                        <td className="text-capitalize">{taskuser.ext_3}</td>
                                        <td>
                                            <span className={`badge ${taskuser.ext_10 === 'New' ? 'bg-success' : 'bg-secondary'}`}>
                                                {taskuser.ext_10}
                                            </span>
                                        </td>
                                        <td className="text-nowrap">{taskuser.ext_13}</td>
                                        <td className="fw-semibold text-primary">{taskuser.class}</td>
                                        <td className="text-center fw-bold">{taskuser.section}</td>
                                        <td className="text-nowrap">
                                            <small>{taskuser.mobile}</small>
                                        </td>
                                        <td className="text-capitalize">{taskuser.ext_11}</td>
                                        {/* <td className="text-capitalize">
                                            {taskuser.head_receipt ? (
                                                <span>{taskuser.head_receipt}</span>
                                            ) : (
                                                <select 
                                                    className="form-select form-select-sm"
                                                    onChange={(e) => handleHeadReceiptChange(taskuser.id, e.target.value, index)}
                                                    defaultValue=""
                                                    style={{fontSize: '0.875rem'}}
                                                >
                                                    <option value="">Select...</option>
                                                    {headReceiptList.map((receipt) => (
                                                        <option key={receipt.id} value={receipt.name}>
                                                            {receipt.name}
                                                        </option>
                                                    ))}
                                                </select>
                                            )}
                                        </td> */}
                                        <td className="text-center">{taskuser.alpha || '-'}</td>
                                        <td className="text-center">
                                            <span className={`badge ${taskuser.reported === 1 ? 'bg-success' : 'bg-secondary'}`}>
                                                {taskuser.reported === 1 ? 'Yes' : 'No'}
                                            </span>
                                        </td>
                                        <td className="text-center">
                                            <div className="btn-group" role="group">
                                                <Link 
                                                    to={`/student_edit/${taskuser.id}`}
                                                    className="btn btn-outline-primary btn-sm"
                                                    title="Edit Student"
                                                >
                                                    <i className="fas fa-edit"></i>
                                                </Link>
                                                <Link 
                                                    to={`/student_view/${taskuser.id}`} 
                                                    className="btn btn-outline-info btn-sm"
                                                    title="View Student"
                                                >
                                                    <i className="fas fa-eye"></i>
                                                </Link>
                                                <button 
                                                    className='btn btn-outline-success btn-sm' 
                                                    onClick={() => openEditModal(taskuser.id, taskuser)}
                                                    title="Upload Photo"
                                                >
                                                    <i className="fas fa-upload"></i>
                                                </button>
                                                {!studentsWithFees.includes(taskuser.id) && feesTemplates.length > 0 && (
                                                    <button
                                                        className="btn btn-outline-warning btn-sm"
                                                        onClick={() => { setSelectedTemplateStudent(taskuser); setSelectedTemplateId(""); setShowTemplateModal(true); }}
                                                        title="Assign Fees Template"
                                                    >
                                                        <i className="fas fa-file-invoice-dollar"></i>
                                                    </button>
                                                )}
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    ) : (
                        <div className="text-center p-4">
                            <p>Please use the filters above and click 'Search' to view students.</p>
                        </div>
                    )}
                        </div>
                    </div>
                </div>
            </div>

            {/* Assign Fees Template Modal */}
            {showTemplateModal && selectedTemplateStudent && (
                <>
                    <div className="modal-backdrop show" style={{ zIndex: 10500 }}></div>
                    <div className="modal show d-block" tabIndex="-1" style={{ zIndex: 10501 }}>
                        <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content">
                                <div className="modal-header py-2 bg-warning bg-opacity-10">
                                    <h6 className="modal-title fw-bold mb-0">
                                        <i className="fas fa-file-invoice-dollar me-2 text-warning"></i>Assign Fees Template
                                    </h6>
                                    <button type="button" className="btn-close" onClick={() => setShowTemplateModal(false)}></button>
                                </div>
                                <div className="modal-body">
                                    <div className="mb-3 p-2 bg-light rounded">
                                        <small className="text-muted">Student:</small>
                                        <div className="fw-bold">{selectedTemplateStudent.ext_2} {selectedTemplateStudent.ext_3}</div>
                                        <small className="text-muted">Adm No: {selectedTemplateStudent.adm_no} | Class: {selectedTemplateStudent.class} - {selectedTemplateStudent.section}</small>
                                    </div>
                                    <label className="form-label fw-semibold" style={{ fontSize: "0.85rem" }}>Select Template *</label>
                                    <div className="list-group mb-3" style={{ maxHeight: "200px", overflowY: "auto" }}>
                                        {feesTemplates.map((t) => (
                                            <label key={t.id} className={`list-group-item list-group-item-action d-flex align-items-center ${selectedTemplateId === String(t.id) ? 'active' : ''}`} style={{ cursor: "pointer", fontSize: "0.85rem" }}>
                                                <input type="radio" name="feesTpl" className="form-check-input me-2" value={t.id} checked={selectedTemplateId === String(t.id)} onChange={(e) => setSelectedTemplateId(e.target.value)} />
                                                {t.name}
                                                <span className="ms-auto badge bg-secondary">{(t.items || []).length} items</span>
                                            </label>
                                        ))}
                                    </div>
                                    {selectedTemplateId && (
                                        <div className="border rounded p-2 bg-light" style={{ fontSize: "0.8rem", maxHeight: "180px", overflowY: "auto" }}>
                                            <small className="fw-bold text-muted">Template Items:</small>
                                            <table className="table table-sm table-borderless mb-0 mt-1">
                                                <tbody>
                                                    {(feesTemplates.find(t => t.id === parseInt(selectedTemplateId))?.items || []).map((item, i) => (
                                                        <tr key={i}>
                                                            <td>{item.fees_type ? item.fees_type.name : `Fee #${item.fees_type_id}`}</td>
                                                            <td className="text-end fw-bold">{parseFloat(item.amount).toLocaleString("en-IN")}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    )}
                                </div>
                                <div className="modal-footer py-2">
                                    <button type="button" className="btn btn-secondary btn-sm" onClick={() => setShowTemplateModal(false)}>Cancel</button>
                                    <button type="button" className="btn btn-warning btn-sm" onClick={handleAssignTemplate} disabled={assigningTemplate || !selectedTemplateId}>
                                        {assigningTemplate ? <><span className="spinner-border spinner-border-sm me-1"></span>Assigning...</> : <><i className="fas fa-check me-1"></i>Assign</>}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </>
    );
}
